import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminPrivateRoute from "./AdminPrivateRoute";
import { Header } from '../../components/Admin/Header/Header.jsx'
import UploadPage from '../../pages/Admin/upload/UploadPage.jsx'
import LoginPage from '../../pages/Admin/Login/LoginPage.jsx'
import useAuth from '../../utils/Admin/helpers/useAuth'
import { Provider } from "react-redux";
import store from "../../store/Admin/store";
import '../../admin-config.css'
import ReportsPage from "../../pages/Admin/Reports/ReportsPage";
import AdminLoader from "../../components/Admin/Loader/AdminLoader";

const AppRoutes = () => {

  const user = useAuth()

  return (
    <div className="bg-custom-grey">
      <Provider store={store}>
      <AdminLoader/>
      <div hidden={!user}>
        <Header />
      </div>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route path="/*" element={<AdminPrivateRoute />}>
            <Route index path="upload" element={<UploadPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="*" element={<Navigate to="upload" replace />} />
          </Route>
          {/* <Route exact={true} path="/admin/mis-recon/*" element={<Navigate to="upload" />} replace/> */}
        </Routes>
      </Provider>
    </div>
  );
};

export default AppRoutes;
